import ProductDetailModal from './scripts';
import './styles/productDetailModal.scss';

export default ProductDetailModal;
